
export function ButtonLink(props) {
    const { name, onClick, url } = props;
    return <a className="d-inline-flex btn justify-content-center align-items-center btn-100 btn-primary gap-2 btn-primary-dark" href={url} onClick={onClick} role="button">
        <span className="icon-container">
            <svg className="btn-star-1" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 13L5.90225 11.3846C5.16734 9.39854 3.60146 7.83266 1.6154 7.09775L5.68248e-07 6.5L1.6154 5.90225C3.60146 5.16734 5.16734 3.60146 5.90225 1.6154L6.5 -5.68248e-07L7.09775 1.6154C7.83266 3.60146 9.39854 5.16734 11.3846 5.90225L13 6.5L11.3846 7.09775C9.39854 7.83266 7.83266 9.39854 7.09775 11.3846L6.5 13Z"></path>
            </svg>
            <svg className="btn-star-2" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 9L4.08617 7.88164C3.57739 6.50668 2.49332 5.42261 1.11836 4.91383L3.93402e-07 4.5L1.11836 4.08617C2.49332 3.57739 3.57739 2.49332 4.08617 1.11835L4.5 -3.93402e-07L4.91383 1.11835C5.42261 2.49332 6.50668 3.57739 7.88165 4.08617L9 4.5L7.88165 4.91383C6.50668 5.42261 5.42261 6.50668 4.91383 7.88164L4.5 9Z"></path>
            </svg>

            <svg className="btn-star-3" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 7L3.17813 6.13017C2.78241 5.06075 1.93925 4.21759 0.869831 3.82187L3.0598e-07 3.5L0.869831 3.17813C1.93925 2.78241 2.78241 1.93925 3.17813 0.869831L3.5 -3.0598e-07L3.82187 0.869831C4.21759 1.93925 5.06075 2.78241 6.13017 3.17813L7 3.5L6.13017 3.82187C5.06075 4.21759 4.21759 5.06075 3.82187 6.13017L3.5 7Z"></path>
            </svg>
        </span>
        <span>{name}</span>
    </a>;
}



